import './index.css'
import { BanquetApp } from '../client/components/App/BanquetApp'
import { banquetSingleSpaReact } from 'banquet-runtime-modules'
import { singleSpaCssLifecycles } from '@toasttab/banquet-single-spa-css'
import { loadTranslations } from '@local/translations'

const version = process.env.PKG_VERSION

const sentryConfig = {
  publicKey: '5be03d53ecf14292a7227f11cbe6362e@o37442',
  projectId: '6741432',
  releaseVersion: version
}

const reactLifecycles = banquetSingleSpaReact({
  cssScope: 'coo',
  // @ts-ignore
  rootComponent: BanquetApp,
  sentry: sentryConfig,
  singleSpaCssLifecycles
})

export const bootstrap = [loadTranslations, ...reactLifecycles.bootstrap]
export const mount = reactLifecycles.mount
export const unmount = reactLifecycles.unmount
